module.exports = __webpack_public_path__ + "8b54a1b7545b2fd0942efecda4df4377.png";